import { render, staticRenderFns } from "./InvitationCardEdit.vue?vue&type=template&id=68774a0f&scoped=true&"
import script from "./InvitationCardEdit.vue?vue&type=script&lang=js&"
export * from "./InvitationCardEdit.vue?vue&type=script&lang=js&"
import style0 from "./InvitationCardEdit.vue?vue&type=style&index=0&id=68774a0f&prod&lang=less&scoped=true&"
import style1 from "./InvitationCardEdit.vue?vue&type=style&index=1&id=68774a0f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68774a0f",
  null
  
)

export default component.exports